export default __webpack_public_path__ + "static/myBambuMain-dc645d772ef52a843b005b5e9c4c63c0.png";